import Layout from './pages/Layout/index'

function App() {

  return (
    <>      
      <Layout />
    </>
  );
}

export default App;
